import React from "react";
import "./condition.scss";
import BackIcon from "../../assets/backIcon.svg";

const Conditions = ({expandValue, toggleExpand}) => {
    return(
        <div className="termsConditions">
            <div className="conditionHeader">
                <div className="mainTitle">
                    TERMS & CONDITIONS
                </div>
                <div className="conditionExpandIcon" onClick={toggleExpand}>
                    {expandValue?
                     <img className="containerOriginal" src={BackIcon} alt="backIcon" />
                    :
                     <img className="containerExpanded" src={BackIcon} alt="backIcon" />
                    }
                </div>
            </div>
            {/* <span className="toggleArrow" onClick={toggleExpand}>
                {expandValue ? '▲' : '▼'}
            </span> */}
            <div className={`conditionPoints ${expandValue ? 'expanded' : ''}`}>
            <ul className="sidePoints-Container">
                <li className="sidePoints-Content">Alcohol will be served to patrons above 21 years of age.</li>
                <li className="sidePoints-Content">The offer may not be applicable on discounted platters, combos, thalis, discounted buffets, as per catch, MRP items, takeaway orders, seafoods, special dishes, special menu, sheesha as per restaurant discretion.</li>
                <li className="sidePoints-Content">The offer cannot be clubbed with in-house offer or offers from other platform.</li>
                <li className="sidePoints-Content">Menu items & Prices may change without prior notice.</li>
                <li className="sidePoints-Content">Club membership, rules will be as per the outlet/clubs discretion.</li>
                <li className="sidePoints-Content">Offer is not applicable on special days, blackout days, public holidays, national holidays.</li>
                <li className="sidePoints-Content">Offer might differ on particular days & timeslot as per restaurant discretion.</li>
                <li className="sidePoints-Content">Banks have no role to play on taxes and charges levied by government and restaurants.</li>
                <li className="sidePoints-Content">Additional services charges on the bill is upto restaurant's discretion.</li>
                <li className="sidePoints-Content">Other T&Cs may apply</li>
            </ul>
            </div>
        </div>
    )
}

export default Conditions;